import { BREAKPOINTS } from '@app/constants/breakpoints';
import { useIsScreenSize } from '@app/utils/hooks';
import { isDefined } from '@app/utils/is';
import { isEmpty } from '@app/utils/isEmpty';
import { Order } from '@typings';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { CheckoutPaymentMethods } from './CheckoutPaymentMethods';

interface Props {
  order: Order.Open | Order.Closed;
}

export const CheckoutPayments = React.memo(({ order }: Props) => {
  const { t } = useTranslation(['payments']);
  const isDesktop = useIsScreenSize(BREAKPOINTS.LG);

  if (!isDefined(order.paymentMethods) || isEmpty(order.paymentMethods)) {
    return null;
  }

  return (
    <div className={!isDesktop ? 'pb-2' : ''}>
      <h3 className="mb-5 heading-3">{t('payments:payment_methods')}</h3>
      <CheckoutPaymentMethods />
      {isDesktop && (
        <div className="flex justify-between py-4">
          <span className="text-neutral-40 body-1">{t('payments:payment_amount_title')}</span>
          <span className="body-1">{order.totals.prepaymentPriceAsText}</span>
        </div>
      )}
    </div>
  );
});
